<template>
  <header>
    <div class="container d-flex justify-content-between">
      <router-link to="/">
        <img src="../assets/images/slm_logo.svg" alt="skroutz last mile logo" />
      </router-link>

      <b-button
        v-if="displayLogin"
        variant="light"
        @click="$router.push('/login')"
      >
        Login
      </b-button>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Navbar',
  props: {
    displayLogin: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style>
header {
  background-color: #fff;
}
header {
  border-bottom: 1px solid #dcdcdc;
  padding: 16px 0;
}
header .container {
  width: 94%;
}
</style>
